export default "https://cdn-static.gokick.com/assets/1d764bbda6f1db3d5ed96a1ece7edd078534d524/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";